import axios from "@/services/middleware/client";
import OpticksBackground from "@/components/ui/OpticksBackground/OpticksBackground";
import OpticksButton from "@/components/ui/OpticksButton/OpticksButton";
import "./PerformanceUnsubscribe.css";
import OpticksMessage from "@/components/ui/OpticksMessage/OpticksMessage";

const PerformanceUnsubscribe = () => {
  let unsubscribeSuccess = false;

  const queryString = window.location.search;
  const emailParam = new URLSearchParams(queryString);
  const emailParsed = emailParam.get("email");

  const handleUnsubscribe = () => {
    const emailValue = { email: emailParsed };

    return axios.post("/performance/unsubscribe", emailValue).then(() => {
      unsubscribeSuccess = true;
    });
  };

  return (
    <OpticksBackground>
      <div className="performance-unsubscribe">
        {unsubscribeSuccess ? (
          <>
            <p>We’ll no longer send you emails of Performance review.</p>
            <OpticksMessage type="success">
              You’re successfully unsubscribed
            </OpticksMessage>
          </>
        ) : (
          <>
            <p>
              By unsubscribing, you will no longer receive performance-related
              emails from us.
            </p>
            <OpticksButton
              variation="secondary"
              onClick={handleUnsubscribe}
              label="Unsubscribe"
            />
          </>
        )}
      </div>
    </OpticksBackground>
  );
};

export default PerformanceUnsubscribe;
